import { render, staticRenderFns } from "./moreTools.vue?vue&type=template&id=1565b7fb&scoped=true"
import script from "./moreTools.vue?vue&type=script&lang=js"
export * from "./moreTools.vue?vue&type=script&lang=js"
import style0 from "./moreTools.vue?vue&type=style&index=0&id=1565b7fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565b7fb",
  null
  
)

export default component.exports